import { fetchRequest } from 'Utils/apiFetchRequest';
import { BrightcovePlayer } from './BrightcovePlayer';
import { WebBrandAlertsClient } from './BrandAlertsClient';
import BrightcovePollsClient from './PollsClient';

const context = window.__VUMEDI_VIDEO_DETAIL_CONTEXT__;

const learningJourneyShowMore = () => {
    const showMoreButtons = Array.from(document.querySelectorAll('.js_relatedGroupButton'));

    if (!showMoreButtons.length) return;

    showMoreButtons.forEach((button) => {
        if (button.dataset.initialized === 'true') return;
        // eslint-disable-next-line no-param-reassign
        button.dataset.initialized = 'true';
        button.addEventListener('click', () => {
            button.closest('.js_relatedContainerGroup').classList.add('is-expanded');
            button.remove();
        });
    });
};

const relatedContentPathSelector = async () => {
    const tabsWrap = document.querySelector('.js_relatedContainerTabs');

    if (!tabsWrap) return;

    const tabs = Array.from(tabsWrap.querySelectorAll('.js_relatedContainerTabsItem'));
    const activeContentElement = document.querySelector('.js_relatedContainerContent.is-active');
    const parentContainerElement = activeContentElement.parentElement;
    const contentElementClasses = activeContentElement.className;
    const autoplayButton = document.querySelector('.js_autoplayButton');

    const tabClickHandler = (tab, tabId) => {
        // Switch between different tabs and content elements
        const viewportWidth = window.innerWidth;
        document.querySelector('.js_relatedContainerContent.is-active').classList.remove('is-active');
        document.querySelector('.js_relatedContainerTabsItem.is-active').classList.remove('is-active');
        document.getElementById(`${tabId}-tab-content`).classList.add('is-active');
        tab.classList.add('is-active');

        const activeTooltipElement = document.querySelector('[data-toggle="tooltip"]:hover');
        if (activeTooltipElement) {
            if (viewportWidth >= 1024) {
                tab.addEventListener('mouseleave', () => {
                    $(activeTooltipElement).tooltip('hide');
                });
            } else {
                setTimeout(() => {
                    $(activeTooltipElement).tooltip('hide');
                }, 3000);
            }
        }
    };

    for (const [index, tab] of tabs.entries()) {
        const { tabUrl, tabId } = tab.dataset;
        const existingContentElement = document.querySelector(`.js_relatedContainerContent#${tabId}-tab-content`);

        if (existingContentElement) {
            // if the tab content elements already exists for this tab, just attach the event handler
            tab.addEventListener('click', () => {
                tabClickHandler(tab, tabId);
            });
        } else {
            // fetch content for each of the tabs and attach the event handler
            const newContentElement = document.createElement('div');
            newContentElement.className = contentElementClasses.replace('is-active', '').trim();
            newContentElement.id = `${tabId}-tab-content`;
            parentContainerElement.insertBefore(newContentElement, autoplayButton);

            /* eslint-disable no-await-in-loop */
            try {
                const response = await fetch(tabUrl);
                if (!response.ok) {
                    throw new Error(`A response error occurred: ${response.statusText}`);
                }

                const data = await response.text();
                newContentElement.innerHTML = data || `<p>There are no videos to display</p>`;
            } catch (error) {
                newContentElement.innerHTML = `<p>An error occurred while fetching videos. Please try again later.</p>`;
            } finally {
                tab.addEventListener('click', () => {
                    tabClickHandler(tab, tabId);
                });

                if (index === tabs.length - 1) {
                    // run the function only once after the last batch of data is collected
                    learningJourneyShowMore();
                }
            }
        }
    }
};

const relatedItemEventTracking = () => {
    const relatedContainer = document.querySelector('.js_relatedContainer');

    if (!relatedContainer) return;

    const {
        fsAbTestName: abTestName,
        fsAbTestVariant: abTestVariant,
        fsMaxLsIndex: maxLsIndex,
    } = relatedContainer.dataset;

    relatedContainer.addEventListener('click', (event) => {
        const item = event.target.closest('.js_relatedVideoCard');

        if (item && item.dataset) {
            const {
                fsRelatedItemIndex: itemIndex,
                fsPathSelectorTabGroup: pathSelector,
                fsItemInLectureSeries: isLsContent,
                fsLearningJourneyGroup: learningJourneyGroup,
                fsLearningJourneyItemIndex: learningJourneyItemIndex,
            } = item.dataset;
            const tags = item.querySelector('.js_relatedVideoCardTagsWrap')?.dataset.tags || [];

            window.eventTracker.trackRelatedContentClick({
                itemIndex,
                tags,
                pathSelector,
                abTestName,
                abTestVariant,
                isLsContent,
                maxLsIndex,
                learningJourneyGroup,
                learningJourneyItemIndex,
            });
        }
    });
};

const jumpToRelatedContent = () => {
    const button = document.querySelector('.js_jumpToRelatedButton');
    const relatedContainer = document.querySelector('.js_relatedContainer');

    const buttonClickHandler = () => {
        relatedContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    };

    if (!button || !relatedContainer) return;

    button.addEventListener('touchend', () => buttonClickHandler());
    button.addEventListener('click', () => buttonClickHandler());
};

const collectHomefeedData = () => {
    const search = new URLSearchParams(window.location.href.split('/').pop());

    if (search.get('source') === 'homefeed') {
        window.eventTracker.trackHomefeedRecommended(context.videoId, search.has('campaign'));
    }
};

document.addEventListener('DOMContentLoaded', () => {
    new BrightcovePlayer()
        .initialize(
            document.getElementById(context.playerTagId),
            context.brightcoveId,
            context.accountId,
            context.playerId,
        )
        .then((player) => {
            if (context.viewedUUID) {
                new WebBrandAlertsClient(player).start();
                new BrightcovePollsClient(player).start();
            }
        });

    // Autoplay
    const toggleAutoplay = document.getElementById(context.toggleAutoplayId);

    toggleAutoplay?.addEventListener('click', (e) => {
        const button = e.target;
        let url = context.autoplayURL;

        if (button.innerHTML === 'ON') {
            url = `${url}?autoplay=False`;
            button.innerHTML = 'OFF';
        } else {
            url = `${url}?autoplay=True`;
            button.innerHTML = 'ON';
        }

        fetchRequest(url).then((data) => {
            window.autoplayEnabled = data.result;
        });
    });

    $('.js_navigationLogInButton').on('click', (event) => {
        event.preventDefault();
        $('#loginOrRegisterModal').modal('show');
    });

    relatedContentPathSelector();
    relatedItemEventTracking();
    jumpToRelatedContent();
    learningJourneyShowMore();
    collectHomefeedData();
});
